import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import CreateNewBrickModal from "./Modals/CreateNewBrickModal";
import BrickTableDetail from "./BrickTableDetail";
import { CustomerDatabaseStore } from "../../../../../store/main/CustomerDatabaseStore";
import { BrickManagementStore } from "../../../../../store/main/BrickManagementStore";
import { FetchState } from "../../../../../domain/models/fetch-state";
import CreateBrickMapViewModal from "./Modals/CreateBrickMapViewModal";
// import HQWiseBricksGeoTagging from "./Modals/FetchHQWiseBricksGeoTagging";
import FetchHQWiseBrickAreaGeoTagging from "./Modals/FetchHQWiseBrickAreaGeoTagging";

interface Payload {
  hq_headquarter_id: string;
  no_of_work_days: number | string;
  name: string;
  expected_business: number | string;
  locality: string;
  distance_from_hq: string | number;
  station: string;
  distance_from_base_brick: number | string;
  base_brick_id?: string | null;
}

const BrickTable = () => {
  const { filterStore, userDetails } = CustomerDatabaseStore();
  const { BrickManagementData, fetchBrickManagementState } =
    BrickManagementStore();
  const [openCreateNewBrick, setOpenCreateNewBrick] = useState<boolean>(false);
  const [isBrickMapModalOpen, setIsBrickMapModalOpen] =
    useState<boolean>(false);
  const [brickPayload, setBrickPayload] = useState<Payload | null>(null);
  const [openHQWiseLocations, setOpenHQWiseLocations] =
    useState<boolean>(false);

  const handleCreateNewBrickSubmit = () => {
    setIsBrickMapModalOpen(false);
    setIsBrickMapModalOpen(true);
  };

  const handleCreateBrickCallback = () => {
    setIsBrickMapModalOpen(false);
  };

  const handleUpdatePayload = (payload: Payload) => {
    setBrickPayload(payload);
  };

  return (
    <>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        paddingY={2}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Stack
            height="20px"
            width="40px"
            border="2px solid #a7a7a8"
            bgcolor="error.dark"
          />
          <Typography>
            *Note: Need to Add Area Geo Tagging
          </Typography>
        </Stack>

        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            sx={{ borderRadius: "30px" }}
            disabled={
              userDetails.button_access === 0 ||
              filterStore.headquarter_ids === undefined ||
              filterStore.headquarter_ids?.length === 0
            }
            color="primary"
            onClick={() => setOpenHQWiseLocations(true)}
          >
            <Typography variant="subtitle2" textTransform="none">
              View Geo Tag on Map
            </Typography>
          </Button>

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            sx={{ borderRadius: "30px" }}
            disabled={
              userDetails.button_access === 0 ||
              filterStore.headquarter_ids === undefined ||
              filterStore.headquarter_ids?.length === 0
            }
            color="primary"
            onClick={() => setOpenCreateNewBrick(true)}
          >
            <Typography variant="subtitle2" textTransform="none">
              Create Brick
            </Typography>
          </Button>
        </Stack>
      </Stack>

      {fetchBrickManagementState === FetchState.SUCCESS && (
        <Stack height={"65vh"} overflow={"scroll"}>
          <TableContainer>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography
                      color={"#828282"}
                      fontSize={12}
                      fontWeight={600}
                      textAlign={"center"}
                    >
                      Headquarter
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={"#828282"}
                      fontSize={12}
                      fontWeight={600}
                      textAlign={"center"}
                    >
                      Brick
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={"#828282"}
                      fontSize={12}
                      fontWeight={600}
                      textAlign={"center"}
                    >
                      Description
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={"#828282"}
                      fontSize={12}
                      fontWeight={600}
                      textAlign={"center"}
                    >
                      HQ/OS/EX
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={"#828282"}
                      fontSize={12}
                      fontWeight={600}
                      textAlign={"center"}
                    >
                      Working Days
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={"#828282"}
                      fontSize={12}
                      fontWeight={600}
                      textAlign={"center"}
                    >
                      Expected Business
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={"#828282"}
                      fontSize={12}
                      fontWeight={600}
                      textAlign={"center"}
                    >
                      Distance From HQ
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={"#828282"}
                      fontSize={12}
                      fontWeight={600}
                      textAlign={"center"}
                    >
                      Base Brick
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={"#828282"}
                      fontSize={12}
                      fontWeight={600}
                      textAlign={"center"}
                    >
                      Distance From Base Brick
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={"#828282"}
                      fontSize={12}
                      fontWeight={600}
                      textAlign={"center"}
                    >
                      Action
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {BrickManagementData.map((zone, key) => (
                  <>
                    {zone.regions.map((region, key) => (
                      <>
                        {region.areas.map((areas, key) => (
                          <>
                            {areas.headquarters.map((hq, key) => (
                              <>
                                {hq.bricks.map((bricks, key) => (
                                  <>
                                    <BrickTableDetail
                                      row={bricks}
                                      hq={hq.headquarter}
                                      hq_id={hq.headquarter_id}
                                      hq_code={hq.headquarter_ga_code}
                                    />
                                  </>
                                ))}
                              </>
                            ))}
                          </>
                        ))}
                      </>
                    ))}
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      )}

      {filterStore.headquarter_ids !== undefined &&
        filterStore?.headquarter_ids?.length > 0 &&
        openHQWiseLocations &&
        filterStore.headquarter_ids[0] !== undefined && (
          <FetchHQWiseBrickAreaGeoTagging
            open={openHQWiseLocations}
            handleClose={() => setOpenHQWiseLocations(false)}
            hq_id={filterStore.headquarter_ids[0]}
          />
        )}


      {userDetails.button_access !== 0 &&
        filterStore.headquarter_ids !== undefined &&
        filterStore?.headquarter_ids?.length > 0 &&
        openCreateNewBrick &&
        filterStore.headquarter_ids[0] !== undefined && (
          <CreateNewBrickModal
            open={openCreateNewBrick}
            handleClose={() => setOpenCreateNewBrick(false)}
            successCallback={handleCreateNewBrickSubmit}
            hq_id={filterStore.headquarter_ids[0]}
            onUpdatePayload={handleUpdatePayload}
          />
        )}

      {userDetails.button_access !== 0 &&
        filterStore.headquarter_ids !== undefined &&
        filterStore?.headquarter_ids?.length > 0 &&
        isBrickMapModalOpen && (
          <CreateBrickMapViewModal
            open={isBrickMapModalOpen}
            handleClose={() => setIsBrickMapModalOpen(false)}
            successCallback={handleCreateBrickCallback}
            payload={brickPayload}
          />
        )}
    </>
  );
};
export default BrickTable;
